import { useSelector } from 'react-redux'
import utils from 'src/slices/utils'
import css from './POSCard.module.scss'

const axios = require('axios')

export default function POSCard({ name, logo, bgColor = 'white', isActive, value }) {
	// const {user, token} = useSelector(state => state.auth)
	const authState = useSelector(state => state.auth)
	const signupState = useSelector(state => state.signup)

	const handleEnable = () => {
		const user = authState.token ? authState.user : signupState.user
		const token = authState.token || signupState.token

		const type = value
		axios
			.get(
				`https://api.dev-box.livecart-production.com/merchant/POS/enable/${user.id}?type=${type}`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			)
			.then(res => {
				if (res.status === 200) {
					window.location = res.data.url
				}
			})
			.catch(error => {
				if (error.response) {
					localStorage.setItem('message', error.response.data.message)
				} else if (error.request) {
					localStorage.setItem('message', error.request)
				} else {
					localStorage.setItem('message', error.message)
				}
			})
	}
	return (
		<div
			className={css['wrapper']}
			onClick={handleEnable}>
			<div
				className={`${css['box']} ${isActive ? css['active'] : ''}`}
				style={{ backgroundColor: bgColor }}>
				{isActive && <i className={`fas fa-check ${css['icon']}`} />}
				{logo}
			</div>
			<span className={css['name']}>{name}</span>
		</div>
	)
}
